"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HotelRatingSquare = _interopRequireDefault(require("../../HotelRatingSquare"));

var HotelCardRating = function HotelCardRating(_ref) {
  var rating = _ref.rating,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var hotelRating = typeof rating === 'number' ? {
    value: rating,
    count: null
  } : rating;
  return /*#__PURE__*/_react["default"].createElement(StyledHotelCardRating, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_HotelRatingSquare["default"], {
    value: hotelRating === null || hotelRating === void 0 ? void 0 : hotelRating.value,
    count: hotelRating === null || hotelRating === void 0 ? void 0 : hotelRating.count,
    showMeta: hotelRating !== null && hotelRating !== void 0 && hotelRating.count ? (hotelRating === null || hotelRating === void 0 ? void 0 : hotelRating.count) > 0 : false
  }));
};

var StyledHotelCardRating = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardRating__StyledHotelCardRating",
  componentId: "sc-kza3ca-0"
})(["display:flex;"]);

var _default = HotelCardRating;
exports["default"] = _default;